/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRoleForSiteAdmin {
  Carrier = 'carrier',
  Consignee = 'consignee',
  Consignor = 'consignor',
  SiteAdmin = 'site_admin'
}
